<template>
  <div
    id="approot"
    data-vuetify
  >
    <v-app>
      <v-main>
        <Header />
        <Toaster />
        <NavBar />
        <router-view />
        <Footer />
        <span id="versionnr">{{ version }}</span>
      </v-main>
      <div id="teleport-target" />
    </v-app>
  </div>
</template>

<script lang="ts" setup>
import NavBar from "@/components/navigation/NavBar.vue";
import Header from "@/components/navigation/Header.vue";
import Footer from "@/components/navigation/Footer.vue";
import Toaster from "@/components/common/Toaster.vue";

console.log(import.meta.env)

const version = "Version " + import.meta.env.VITE_APP_VERSION
</script>

<style lang="scss">
  #versionnr {
    position: fixed;
    bottom:0;
    right:1em;
    display:block;
    font-size: .875rem;
    color: #444;
  }

</style>
